/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = Age
 *
 * 2 = License
 *
 * 3 = Involved
 *
 * 4 = InsuranceExcess
 *
 * 5 = Prosecuted
 */
export enum TestDriveOptionsEnum {
  Age = 1,
  License = 2,
  Involved = 3,
  InsuranceExcess = 4,
  Prosecuted = 5,
}
